import { render, staticRenderFns } from "./InquiryListTypeCheckGroup.vue?vue&type=template&id=f5ee7f6c&"
import script from "./InquiryListTypeCheckGroup.vue?vue&type=script&lang=ts&"
export * from "./InquiryListTypeCheckGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports